/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    var total_price = cart.total_price;
    var adev_notification_shipping = '';
    var adev_notification_class_shipping = '';
    
    var adev_notify_shipping = $('[data-adev-free-shipping-bar]')
    var adev_notify_shipping_target = parseFloat(adev_notify_shipping.data('target'))

    if(total_price < adev_notify_shipping_target) {
      adev_notification_shipping = adev_notify_shipping.data('progress-text').replace('{amount}', Shopify.formatMoney(adev_notify_shipping_target - total_price));
      adev_notification_class_shipping = 'adev-free-product-notification';
    } else {
      adev_notification_shipping = adev_notify_shipping.data('done-text');
      adev_notification_class_shipping = 'adev-free-product-notification done';
    }

    $('[data-adev-free-shipping-bar]').removeClass().addClass(adev_notification_class_shipping).text(adev_notification_shipping)

    if (cart.item_count > 0) {

      var items_count = cart.item_count;
      var adev_notification = '';
      var adev_notification_class = '';
      var adev_notify = $('[data-adev-notify-bar]')
      var adev_notify_target = parseInt(adev_notify.data('target'))

      if(items_count <= parseInt(adev_notify_target - 2)) {
        adev_notification = adev_notify.data('progress-text').replace('{amount}', parseInt(parseInt(adev_notify_target - 1) - items_count));
        adev_notification_class = 'adev-free-product-notification in-progress';
      }
      console.log(parseInt(adev_notify_target - 1));
      if(items_count == parseInt(adev_notify_target - 1)) {
        adev_notification = adev_notify.data('during-text');
        adev_notification_class = 'adev-free-product-notification earned';
      }
      if(items_count > parseInt(adev_notify_target - 1)) {
        adev_notification = adev_notify.data('done-text');
        adev_notification_class = 'adev-free-product-notification done';
      }

      $('[data-adev-notify-bar]').removeClass().addClass(adev_notification_class).text(adev_notification)

      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;